var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({staticClass:"btn-call",class:{
    calling: _vm.calling,
  },attrs:{"color":_vm.calling ? 'red' : 'green',"fab":!_vm.small,"large":"","icon":_vm.small},on:{"click":_vm.onClick}},'v-btn',_vm.btnProps,false),[_c('v-icon',{staticClass:"icon-phone",class:{ 'mdi-rotate-135': _vm.calling },attrs:{"large":""}},[_vm._v(" mdi-phone ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }